import { TrimmedLabel } from '@ui-kit'

export const Phone = ({ phone }: { phone: string }) => (
  <TrimmedLabel label={phone} maxNumberOfCharacters={25} />
)
